import * as THREE from 'three';

import { Measure, MeasureTools, Point, MeasureConstructorArgs } from './Measure';

export class CadObject extends Measure {
  constructor(args: MeasureConstructorArgs) {
    super({ ...args, isCADMeasure: true });
    this.lineMaterial.linewidth = 1.5;
  }

  updatePositions() {
    if (this.points.length === 0) return;

    this.updateObjectPosition();

    if (this.points.length === 1) {
      this.updatePointPosition(0);
      return;
    }

    for (let index = 0; index < this.points.length; index++) {
      this.updatePointPosition(index);
    }

    this.updateLinePositions();
  }

  updateScales() {
    // could be optimised, only needed when window size has changed
    const renderAreaSize = this.viewer.renderer.getSize(new THREE.Vector2());
    const clientWidth = renderAreaSize.width;
    const clientHeight = renderAreaSize.height;

    this.lineMaterial.resolution.set(clientWidth, clientHeight);
  }
}

export class AreaCadObject extends CadObject {
  constructor({ points, ...args }: { points?: Point[] } & MeasureConstructorArgs) {
    super(args);
    this.type = MeasureTools.AREA;
    this.maxMarkers = Infinity;
    this.closed = true;
    if (points) points.forEach((point) => this.points.push({ position: point.position }));
    this.needsUpdate = true;
  }
}

export class DistanceCadObject extends CadObject {
  constructor({ points, ...args }: { points?: Point[] } & MeasureConstructorArgs) {
    super(args);
    this.type = MeasureTools.DISTANCE;
    this.maxMarkers = Infinity;
    this.closed = false;
    if (points) points.forEach((point) => this.points.push({ position: point.position }));
    this.needsUpdate = true;
  }
}

export class PointCadObject extends CadObject {
  constructor({ point, ...args }: { point?: Point } & MeasureConstructorArgs) {
    super(args);
    this.type = MeasureTools.POINT;
    this.maxMarkers = 1;
    this.closed = true;
    if (point) this.points.push({ position: point.position });
    this.needsUpdate = true;
  }
}
